import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Input, Button, Select, Form, Space, DatePicker, Cascader, Upload, message, Row, Col } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosTable, axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { tailLayout, ngetBase64 } from '../../js/globalParam'
import { apiPrefix } from '../../js/config'
import moment from 'moment'
import _ from 'lodash'

const { Option } = Select
const { TextArea } = Input
const dateFormat = 'YYYY-MM-DD';

function beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG格式的图片文件!')
    }

    const isLt3M = file.size / 1024 / 1024 < 3
    if (!isLt3M) {
        message.error('上传图片不能大于3MB!')
    }

    return isJpgOrPng && isLt3M
}

export default function ArchivesEdit() {

    const { id }: { id: string | undefined } = useParams()
    const [form] = Form.useForm()

    const [pageTitle, setPageTitle] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)

    const [departmentList, setDepartmentList] = useState<any>([])
    const [coperationList, setCoperationList] = useState<any>([])
    const [starLevelList, setStarLevelList] = useState<any>([])

    const [response, setResponse] = useState<any>({})
    const [defaultLocal, setDefaultLocal] = useState<any[]>()
    const [options, setOptions] = React.useState([]);

    const [advantage, setAdvantage] = useState<any[]>([])
    const [skill, setSkill] = useState<any[]>([])

    const [advantageOption, setAdvantageOption] = useState<any>({})
    const [skillOption, setSkillOption] = useState<any>({})

    const [inOutVisble, setInOutVisble] = useState<boolean>(false)
    const [statusVisble, setStatusVisble] = useState<boolean>(false)

    useEffect(() => {
        // 查看组织列表
        axiosTable.get("/global/first_dept_list_of_tenant", {}).then((res: any) => {
            res && setDepartmentList(res)
        })

        // 查看合作商列表
        axiosTable.get("/yuesao_center/global/coperation_list", {}).then((res: any) => {
            res && setCoperationList(res)
        })

        // 查询标准星级列表
        baseAxiosNoInfo.get("/yuesao_center/global/star_level_list", {}).then((res: any) => {
            res && setStarLevelList(res)
        })

        // 查询月嫂优势标签
        axiosTable.get('/manage_center/flag/list', {
            params: {
                flag_type: 4
            }

        }).then((response: any) => {
            setAdvantage(response)
        })

        // 查询月嫂技能标签
        axiosTable.get('/manage_center/flag/list', {
            params: {
                flag_type: 5
            }

        }).then((response: any) => {
            setSkill(response)
        })

        if (id) {
            baseAxiosNoInfo('/yuesao_center/manage/archives/detail', {
                params: { archives_id: id }
            }).then((res: any) => {
                if (res) {
                    // 处理相关图片
                    res.head_pic_url = res.head_pic_url ? [{ id: '', response: { data: [res.head_pic_url] }, url: res.head_pic_url }] : []

                    res.cert_pic_url = res.cert_pic_url ? res.cert_pic_url.split(',').reduce((acc: Array<any>, item: any) => {
                        acc.push({ id: '', response: { data: [item] }, url: item })
                        return acc
                    }, []) : []

                    res.check_report_url = res.check_report_url ? res.check_report_url.split(',').reduce((acc: Array<any>, item: any) => {
                        acc.push({ id: '', response: { data: [item] }, url: item })
                        return acc
                    }, []) : []

                    res.service_diet_url = res.service_diet_url ? res.service_diet_url.split(',').reduce((acc: Array<any>, item: any) => {
                        acc.push({ id: '', response: { data: [item] }, url: item })
                        return acc
                    }, []) : []

                    res.service_photo_url = res.service_photo_url ? res.service_photo_url.split(',').reduce((acc: Array<any>, item: any) => {
                        acc.push({ id: '', response: { data: [item] }, url: item })
                        return acc
                    }, []) : []

                    res.advantages = res.advantages ? res.advantages.split(',').reduce((acc: Array<any>, item: any) => {
                        acc.push(item)
                        return acc
                    }, []) : []

                    res.skills = res.skills ? res.skills.split(',').reduce((acc: Array<any>, item: any) => {
                        acc.push(item)
                        return acc
                    }, []) : []

                    let arr = [res.province_name, res.city_name]
                    res.native_place = arr
                    setDefaultLocal(arr)
                    setResponse(res)

                    form.setFieldsValue({
                        user_name: res.user_name,
                        phone: res.phone,
                        head_pic_url: res.head_pic_url,
                        age: res.age,
                        province_code: res.province_code,
                        province_name: res.province_name,
                        city_code: res.city_code,
                        city_name: res.city_name,
                        native_place: res.native_place,
                        address: res.address,
                        service_type: res.service_type,
                        star_level_id: res.star_level_id,
                        salary_in_house: res.salary_in_house,
                        salary_home: res.salary_home,
                        in_out: res.in_out,
                        coperation_id: res.coperation_id,
                        status: res.status,
                        in_date: res.in_date ? moment(res.in_date) : null,
                        out_date: res.out_date ? moment(res.out_date) : null,
                        work_years_type: res.work_years_type,
                        is_promoted: res.is_promoted,
                        department_id: res.department_id,
                        profile: res.profile,
                        advantages: res.advantages,
                        skills: res.skills,
                        work_experience: res.work_experience,
                        cert_pic_url: res.cert_pic_url,
                        check_report_url: res.check_report_url,
                        service_diet_url: res.service_diet_url,
                        service_photo_url: res.service_photo_url
                    })

                    res.in_out == 1 ? setInOutVisble(false) : setInOutVisble(true)

                    setAdvantageOption({ values: res.advantages })
                    setSkillOption({ values: res.skills })

                    let targetOption: any = [];

                    axiosTable.get("/global/province_list", { params: {} }).then((result: any) => {
                        for (let i of result) {
                            i.type = 'province';
                            i.code = i.province_code;
                            i.name = i.province_name;
                            i.short_name = i.short_name;
                            i.isLeaf = false;
                        }

                        targetOption = result

                    }).then(() => {
                        axiosTable.get("/global/city_list", { params: { province_code: res.province_code } }).then((result: any) => {
                            for (let i of result) {
                                i.type = 'city';
                                i.code = i.city_code;
                                i.name = i.city_name;
                                i.isLeaf = false;
                            }

                            for (let i of targetOption) {
                                if (i.province_code == res.province_code) {
                                    i.children = result;
                                }
                            }

                            setOptions(targetOption)
                        })
                    })
                }
            })

            setPageTitle('编辑月嫂档案')

        } else {
            setPageTitle('新增月嫂档案')
            getProvince()
        }
    }, [])

    const phoneValidator = (_: any, value: any) => {
        if (!value) {
            return Promise.reject('手机号必填')
        }

        if (/^1[3456789]\d{9}$/.test(value)) {
            return Promise.resolve()
        } else {
            return Promise.reject('输入11位手机号')
        }
    }

    const handleChange = (value: number, attr: string) => {
        if (attr == 'in_out') {
            value == 1 ? setInOutVisble(false) : setInOutVisble(true)
        }

        if (attr == 'status') {
            value == 1 ? setStatusVisble(false) : setStatusVisble(true)
        }
    }

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }
    }

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>上传</div>
        </div>
    )

    const getProvince = () => {
        axiosTable.get("/global/province_list", { params: {} }).then((res: any) => {
            for (let i of res) {
                i.type = 'province';
                i.name = i.province_name;
                i.short_name = i.short_name;
                i.code = i.province_code;
                i.isLeaf = false;
            }

            setOptions(res)
        })
    }

    const loadData = (selectedOptions: any) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;

        // 省的情况
        if (targetOption.type == "province") {
            axiosTable.get("/global/city_list", { params: { province_code: targetOption.code } }).then((res: any) => {
                targetOption.loading = false

                for (let i of res) {
                    i.type = 'city';
                    i.name = i.city_name;
                    i.code = i.city_code;
                    i.isLeaf = false;
                }

                targetOption.children = res;
                setOptions([...options]);
            })
        }
    }

    const onChange = (value: any, selectedOptions: any) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        const nresponse: any = _.cloneDeep(response);

        if (selectedOptions.length == 2) {
            response.province_code = selectedOptions[0].province_code;
            response.province_name = selectedOptions[0].province_name;
            response.city_code = selectedOptions[1].city_code;
            response.city_name = selectedOptions[1].city_name;

            setResponse(response)

        } else {
            nresponse.isSelectLocal = false;
            nresponse.lng = ''
            nresponse.lat = ''
            nresponse.detail_address = null

            setResponse(nresponse)
        }
    }

    const handleSelectAdvantage = (values: any, options: any) => {
        let newOptions = {
            options,
            values
        }

        setAdvantageOption(newOptions)
    }

    const handleSelectSkill = (values: any, options: any) => {
        let newOptions = {
            options,
            values
        }

        setSkillOption(newOptions)
    }

    const onFinish = (values: any) => {
        let url = id ? '/yuesao_center/manage/archives/update' : '/yuesao_center/manage/archives/add'

        let advantageFlag: any = '';
        let skillFlag: any = '';

        if (id) {
            if (advantageOption.options == undefined) {
                advantageFlag = values.advantages;

            } else {
                for (let b of advantageOption.options) {
                    for (let i of values.advantages) {
                        if (i.value == b.value) {
                            b.color = i.color;
                        }
                    }
                }

                advantageFlag = advantageOption.options
            }

            if (skillOption.options == undefined) {
                skillFlag = values.skills;

            } else {
                for (let b of skillOption.options) {
                    for (let i of values.skills) {
                        if (i.value == b.value) {
                            b.color = i.color;
                        }
                    }
                }

                skillFlag = skillOption.options
            }

        } else {
            advantageFlag = advantageOption.options
            skillFlag = skillOption.options
        }

        advantageFlag = advantageFlag.reduce((acc: any, item: any) => {
            acc += `${item.value},`
            return acc
        }, '')

        skillFlag = skillFlag.reduce((acc: any, item: any) => {
            acc += `${item.value},`
            return acc
        }, '')

        values.advantages = advantageFlag ? advantageFlag.substring(0, advantageFlag.length - 1) : ''
        values.skills = skillFlag ? skillFlag.substring(0, skillFlag.length - 1) : ''

        // 处理头像
        if (values.head_pic_url && values.head_pic_url.length > 0) {
            values.head_pic_url = values.head_pic_url[0].response.data[0]
        } else {
            values.head_pic_url = ''
        }

        // 处理证书照片
        if (values.cert_pic_url && values.cert_pic_url.length > 0) {
            values.cert_pic_url_list = values.cert_pic_url.reduce((acc: any, item: any) => {
                if (item.response && item.response.data) {
                    acc.push(item.response.data[0])
                }

                return acc
            }, [])
        }

        // 处理健康证照片
        if (values.check_report_url && values.check_report_url.length > 0) {
            values.check_report_url_list = values.check_report_url.reduce((acc: any, item: any) => {
                if (item.response && item.response.data) {
                    acc.push(item.response.data[0])
                }

                return acc
            }, [])
        }

        // 处理月子餐照片
        if (values.service_diet_url && values.service_diet_url.length > 0) {
            values.service_diet_url_list = values.service_diet_url.reduce((acc: any, item: any) => {
                if (item.response && item.response.data) {
                    acc.push(item.response.data[0])
                }

                return acc
            }, [])
        }

        // 处理月子服务照片
        if (values.service_photo_url && values.service_photo_url.length > 0) {
            values.service_photo_url_list = values.service_photo_url.reduce((acc: any, item: any) => {
                if (item.response && item.response.data) {
                    acc.push(item.response.data[0])
                }

                return acc
            }, [])
        }

        // 处理个人优势
        if (values.advantages.includes("undefined")) {
            values.advantages = response.advantages.reduce((acc: any, item: any) => {
                acc += `${item},`
                return acc
            }, '')

            values.advantages = values.advantages ? values.advantages.substring(0, values.advantages.length - 1) : ''
        }

        // 处理专业技能
        if (values.skills.includes("undefined")) {
            values.skills = response.skills.reduce((acc: any, item: any) => {
                acc += `${item},`
                return acc
            }, '')

            values.skills = values.skills ? values.skills.substring(0, values.skills.length - 1) : ''
        }

        const submitData = {
            id,
            user_name: values.user_name,
            phone: values.phone,
            head_pic_url: values.head_pic_url,
            age: values.age,
            province_code: response.province_code,
            province_name: response.province_name,
            city_code: response.city_code,
            city_name: response.city_name,
            address: values.address,
            service_type: values.service_type,
            star_level_id: values.star_level_id,
            salary_in_house: values.salary_in_house,
            salary_home: values.salary_home,
            in_out: values.in_out,
            coperation_id: values.in_out === 2 ? values.coperation_id : null,
            status: values.status,
            in_date: values.in_date ? values.in_date.format(dateFormat) : null,
            out_date: values.status === 2 && values.out_date ? values.out_date.format(dateFormat) : null,
            work_years_type: values.work_years_type,
            is_promoted: values.is_promoted,
            department_id: values.department_id,
            profile: values.profile,
            advantages: values.advantages,
            skills: values.skills,
            work_experience: values.work_experience,
            cert_pic_url_list: values.cert_pic_url_list || [],
            check_report_url_list: values.check_report_url_list || [],
            service_diet_url_list: values.service_diet_url_list || [],
            service_photo_url_list: values.service_photo_url_list || []
        }

        axiosHandleEvent.post(url, submitData)
    }

    // 表单布局：左边标签，右边输入框
    const formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
    }

    return (<div className="common-level2-edit">
        {/* 月嫂中心 -> 月嫂管理 -> 月嫂档案 -> 新增或编辑 */}
        <h2 style={{ marginBottom: 10 }}>{pageTitle}</h2>

        <div className="common-main" style={{ background: '#fff', borderRadius: '8px' }}>
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish} layout="horizontal" labelAlign="left">
                {/* ===== 基础信息 ===== */}
                <div style={{ marginBottom: 10 }}>
                    <h3 style={{ marginBottom: 20 }} />

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="姓名" name="user_name" rules={[{ required: true, message: '请输入姓名' }]}>
                                <Input placeholder="请输入姓名" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="手机号" name="phone" rules={[{ required: true, validator: phoneValidator }]}>
                                <Input placeholder="请输入手机号" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="年龄" name="age" rules={[{ required: true, message: '请输入年龄' }]}>
                                <Input type="number" min="1" max="99" placeholder="请输入年龄" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="籍贯" name="native_place">
                                <Cascader defaultValue={defaultLocal} options={options} fieldNames={{ label: 'name', value: 'name' }} loadData={loadData} onChange={onChange} changeOnSelect />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="住址" name="address">
                                <Input placeholder="请输入详细住址" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="服务类型" name="service_type" rules={[{ required: true, message: '请选择服务类型' }]}>
                                <Select placeholder="请选择服务类型">
                                    <Option value={1}>馆内</Option>
                                    <Option value={2}>住家</Option>
                                    <Option value={3}>两者均可</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="护理师星级" name="star_level_id" rules={[{ required: true, message: '请选择星级' }]}>
                                <Select placeholder="请选择星级">
                                    {starLevelList.map((item: any) => {
                                        return <Option value={item.star_level_id} key={item.star_level_id}>{item.star_level_name}</Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="护理师薪酬（一对一）" name="salary_in_house">
                                <Input type="number" placeholder="请输入薪酬" addonAfter="元" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="护理师薪酬（住家）" name="salary_home">
                                <Input type="number" placeholder="请输入薪酬" addonAfter="元" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="员工类型" name="in_out" rules={[{ required: true, message: '请选择员工类型' }]}>
                                <Select placeholder="请选择员工类型" onChange={(value: number) => { handleChange(value, 'in_out') }}>
                                    <Option value={1}>内部员工</Option>
                                    <Option value={2}>合作商员工</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        {inOutVisble && (
                            <Col xs={24} sm={12} md={12}>
                                <Form.Item label="合作商" name="coperation_id" rules={[{ required: true, message: '请选择合作商' }]}>
                                    <Select placeholder="请选择合作商">
                                        {coperationList.map((item: any) => {
                                            return <Option value={item.coperation_id} key={item.coperation_id}>{item.coperation_name}</Option>
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="员工状态" name="status" rules={[{ required: true, message: '请选择员工状态' }]}>
                                <Select placeholder="请选择员工状态" onChange={(value: number) => { handleChange(value, 'status') }}>
                                    <Option value={1}>在职</Option>
                                    <Option value={2}>离职</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="入职日期" name="in_date" rules={[{ required: true, message: '请选择入职日期' }]}>
                                <DatePicker style={{ width: '100%' }} placeholder="请选择入职日期" />
                            </Form.Item>
                        </Col>
                    </Row>

                    {statusVisble && (
                        <Row gutter={[24, 0]}>
                            <Col xs={24} sm={12} md={12}>
                                <Form.Item label="离职日期" name="out_date" rules={[{ required: true, message: '请选择离职日期' }]}>
                                    <DatePicker style={{ width: '100%' }} placeholder="请选择离职日期" />
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="工作经验" name="work_years_type" rules={[{ required: true, message: '请选择工作经验' }]}>
                                <Select placeholder="请选择工作经验">
                                    <Option value={1}>0年</Option>
                                    <Option value={2}>1年</Option>
                                    <Option value={3}>2年</Option>
                                    <Option value={4}>3年</Option>
                                    <Option value={5}>4年</Option>
                                    <Option value={6}>5年</Option>
                                    <Option value={7}>6年</Option>
                                    <Option value={8}>7年</Option>
                                    <Option value={9}>8年</Option>
                                    <Option value={10}>9年</Option>
                                    <Option value={11}>10年</Option>
                                    <Option value={12}>10年以上</Option>
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="是否可晋级" name="is_promoted" rules={[{ required: true, message: '请选择是否可晋级' }]}>
                                <Select placeholder="请选择是否可晋级">
                                    <Option value={1}>是</Option>
                                    <Option value={0}>否</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item label="所属门店" name="department_id" rules={[{ required: true, message: '请选择所属门店' }]}>
                                <Select placeholder="请选择所属门店">
                                    {departmentList.map((item: any) => {
                                        return <Option value={item.department_id} key={item.department_id}>{item.department_name}</Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="head_pic_url" label="形象照片" valuePropName="fileList" getValueFromEvent={uploadFile} >
                                <Upload
                                    maxCount={1}
                                    name="files"
                                    onPreview={handlePreview}
                                    beforeUpload={beforeUpload}
                                    data={{ fileType: 1, bucketType: 4 }}
                                    action={apiPrefix + '/global/upload_pic'}
                                    listType="picture-card"
                                >
                                    {uploadButton}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                {/* ===== 详情信息 ===== */}
                <div style={{ marginBottom: 24 }}>
                    <h3 style={{ borderBottom: '2px solid #f0f0f0', marginBottom: 20 }} />

                    <Row>
                        <Col sm={12} >
                            <Form.Item label="个人简介" name="profile" wrapperCol={{ span: 20, offset: 0 }}>
                                <TextArea rows={4} placeholder="请输入个人简介" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <Form.Item label="个人优势" name="advantages" wrapperCol={{ span: 20, offset: 0 }}>
                                <Select
                                    mode="multiple"
                                    value={advantageOption.values}
                                    placeholder="请选择个人优势"
                                    onChange={handleSelectAdvantage}
                                    style={{ width: '100%' }}
                                >
                                    {advantage.map((item: any) => {
                                        return <Option value={item.label_name} color={item.label_color} key={item.id} >{item.label_name}</Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <Form.Item label="专业技能" name="skills" wrapperCol={{ span: 20, offset: 0 }}>
                                <Select
                                    mode="multiple"
                                    value={skillOption.values}
                                    placeholder="请选择个人优势"
                                    onChange={handleSelectSkill}
                                    style={{ width: '100%' }}
                                >
                                    {skill.map((item: any) => {
                                        return <Option value={item.label_name} color={item.label_color} key={item.id} >{item.label_name}</Option>
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12} >
                            <Form.Item label="工作经历" name="work_experience" wrapperCol={{ span: 20, offset: 0 }}>
                                <TextArea rows={4} placeholder="请输入工作经历" />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                {/* ===== 证书照片 ===== */}
                <div style={{ marginBottom: 24 }}>
                    <h3 style={{ borderBottom: '2px solid #f0f0f0', marginBottom: 20 }} />

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="cert_pic_url" label="证书照片" valuePropName="fileList" getValueFromEvent={uploadFile} wrapperCol={{ span: 20, offset: 0 }}>
                                <Upload
                                    maxCount={6}
                                    name="files"
                                    onPreview={handlePreview}
                                    beforeUpload={beforeUpload}
                                    data={{ fileType: 1, bucketType: 4 }}
                                    action={apiPrefix + '/global/upload_pic'}
                                    listType="picture-card"
                                >
                                    {uploadButton}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="check_report_url" label="健康证照片" valuePropName="fileList" getValueFromEvent={uploadFile} wrapperCol={{ span: 20, offset: 0 }}>
                                <Upload
                                    maxCount={6}
                                    name="files"
                                    onPreview={handlePreview}
                                    beforeUpload={beforeUpload}
                                    data={{ fileType: 1, bucketType: 4 }}
                                    action={apiPrefix + '/global/upload_pic'}
                                    listType="picture-card"
                                >
                                    {uploadButton}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                {/* ===== 服务照片 ===== */}
                <div style={{ marginBottom: 24 }}>
                    <h3 style={{ borderBottom: '2px solid #f0f0f0', marginBottom: 20 }} />

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="service_diet_url" label="月子餐照片" valuePropName="fileList" getValueFromEvent={uploadFile} wrapperCol={{ span: 20, offset: 0 }} >
                                <Upload
                                    maxCount={9}
                                    name="files"
                                    onPreview={handlePreview}
                                    beforeUpload={beforeUpload}
                                    data={{ fileType: 1, bucketType: 4 }}
                                    action={apiPrefix + '/global/upload_pic'}
                                    listType="picture-card"
                                >
                                    {uploadButton}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[24, 0]}>
                        <Col xs={24} sm={12} md={12}>
                            <Form.Item name="service_photo_url" label="月子服务照片" valuePropName="fileList" getValueFromEvent={uploadFile} wrapperCol={{ span: 20, offset: 0 }} >
                                <Upload
                                    maxCount={9}
                                    name="files"
                                    onPreview={handlePreview}
                                    beforeUpload={beforeUpload}
                                    data={{ fileType: 1, bucketType: 4 }}
                                    action={apiPrefix + '/global/upload_pic'}
                                    listType="picture-card"
                                >
                                    {uploadButton}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </div>

                {/* ===== 提交按钮 ===== */}
                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    </div>
    )
}